export default __webpack_public_path__ + "static/soldOut-01d9e80ebea1c8c6f88d6e558957bf2c.png";